import { PortalAcademicPage } from './PortalAcademicPage';
import { PortalApplicationsPage } from './PortalApplicationsPage';
import { PortalDashboardPage } from './PortalDashboardPage';
import { PortalAttendancePage } from './PortalAttendancePage';
import { PortalCalendarPage } from './PortalCalendarPage';
import { PortalEnrollmentPage } from './PortalEnrollmentPage';
import { PortalEnrollmentStatusPage } from './PortalEnrollmentStatusPage';
import { PortalFinancialAidPage } from './PortalFinancialAidPage';
import { PortalResourcesPage } from './PortalResourcesPage';
import { PortalSettingsPage } from './PortalSettingsPage';
import { PortalTuitionPage } from './PortalTuitionPage';
import ApplicationsIntakeApp from '../../internal-owned/portal-applications-v2-1/App';

export type ParentPortalPageMode =
  | 'applications'
  | 'enrollment'
  | 'financial-aid'
  | 'dashboard'
  | 'settings'
  | 'calendar'
  | 'tuition'
  | 'attendance'
  | 'academic'
  | 'resources'
  | 'intake-applications'
  | 'intake-enrollment'
  | 'intake-financial-aid'
  | 'intake-settings';

const IntakeApplicationsSurface = () => (
  <section data-testid="parent-portal-intake-applications" data-extracted-from="owned:ystnj/parent-portal/intake-applications">
    <ApplicationsIntakeApp />
  </section>
);

export function ParentPortalPage({ mode }: { mode: ParentPortalPageMode }) {
  switch (mode) {
    case 'dashboard':
      return <PortalDashboardPage />;
    case 'applications':
      return <PortalApplicationsPage />;
    case 'intake-applications':
      return <IntakeApplicationsSurface />;
    case 'enrollment':
      return <PortalEnrollmentStatusPage />;
    case 'intake-enrollment':
      return <PortalEnrollmentPage />;
    case 'financial-aid':
      return <PortalFinancialAidPage />;
    case 'intake-financial-aid':
      return <PortalFinancialAidPage />;
    case 'settings':
    case 'intake-settings':
      return <PortalSettingsPage />;
    case 'calendar':
      return <PortalCalendarPage />;
    case 'tuition':
      return <PortalTuitionPage />;
    case 'attendance':
      return <PortalAttendancePage />;
    case 'academic':
      return <PortalAcademicPage />;
    case 'resources':
      return <PortalResourcesPage />;
    default:
      return <PortalApplicationsPage />;
  }
}
